import { render, staticRenderFns } from "./CarryOverInvoice.vue?vue&type=template&id=174130b2&"
import script from "./CarryOverInvoice.vue?vue&type=script&lang=ts&"
export * from "./CarryOverInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./CarryOverInvoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports